import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-difficulty-circle',
    templateUrl: './difficulty-circle.component.html',
    styleUrls: ['./difficulty-circle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DifficultyCircleComponent implements OnInit {
  @Input() difficulty:number = 0;
  constructor() { }

  ngOnInit(): void {
  }


}
